var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEasySignUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6701_2385)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6701_2385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 70
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H70V70H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6701_2385)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6701_2385",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 9,
    width: 70,
    height: 53
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.3335H70V61.7927H0V9.3335Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6701_2385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.4168 55.7307L64.7641 47.9502C64.2458 47.0781 63.4058 46.4442 62.425 46.185C62.785 45.6259 62.977 44.9752 62.978 44.3102V12.8335C62.978 11.9052 62.6092 11.015 61.9528 10.3586C61.2965 9.70224 60.4062 9.3335 59.478 9.3335H10.5188C9.59054 9.3335 8.7003 9.70224 8.04392 10.3586C7.38755 11.015 7.0188 11.9052 7.0188 12.8335V44.3067C7.02177 45.0941 7.29295 45.857 7.78763 46.4697C7.23752 46.7498 6.76202 47.1569 6.40047 47.6573L0.771298 55.4402C0.338596 56.0264 0.0748308 56.72 0.00866205 57.4456C-0.0575067 58.1712 0.0764522 58.9011 0.395983 59.5559C0.715514 60.2107 1.20839 60.7654 1.82107 61.1598C2.43374 61.5541 3.14278 61.773 3.87113 61.7927H66.1291C66.8289 61.7754 67.5117 61.5738 68.1087 61.2084C68.7058 60.843 69.1959 60.3267 69.5297 59.7114C69.8634 59.0961 70.0291 58.4037 70.0099 57.704C69.9907 57.0043 69.7873 56.322 69.4203 55.726M8.76997 12.8335C8.76997 12.3694 8.95434 11.9242 9.28253 11.5961C9.61072 11.2679 10.0558 11.0835 10.52 11.0835H59.4803C59.9444 11.0835 60.3895 11.2679 60.7177 11.5961C61.0459 11.9242 61.2303 12.3694 61.2303 12.8335V44.3067C61.2303 44.7708 61.0459 45.2159 60.7177 45.5441C60.3895 45.8723 59.9444 46.0567 59.4803 46.0567H10.5188C10.0547 46.0567 9.60955 45.8723 9.28136 45.5441C8.95317 45.2159 8.7688 44.7708 8.7688 44.3067L8.76997 12.8335ZM67.9445 58.9588C67.7672 59.286 67.5051 59.5595 67.1857 59.7504C66.8662 59.9413 66.5013 60.0427 66.1291 60.0438H3.87113C3.48172 60.0448 3.09994 59.9358 2.76972 59.7294C2.4395 59.523 2.17424 59.2276 2.00446 58.8772C1.80529 58.4988 1.71682 58.072 1.74922 57.6456C1.78162 57.2193 1.93357 56.8107 2.18763 56.4668L7.8168 48.6817C8.00828 48.4129 8.26061 48.1932 8.55319 48.0405C8.84576 47.8878 9.1703 47.8065 9.5003 47.8032H61.473C61.8362 47.8053 62.1925 47.9025 62.5065 48.085C62.8204 48.2676 63.0811 48.5292 63.2626 48.8438L67.9188 56.6278C68.1319 56.9787 68.2468 57.3805 68.2513 57.791C68.2558 58.2015 68.1498 58.6057 67.9445 58.9612",
    fill: "#1A1818"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6701_2385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasySignUp);
export default __webpack_public_path__ + "static/media/easy-sign-up.cefb77dca07b788ac0af1559f589547c.svg";
export { ForwardRef as ReactComponent };